import React from "react";
import Backdrop from "@mui/material/Backdrop";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import CloseIcon from "@mui/icons-material/Close";

export default function DeleteConfirmModal({ item, onClose, onConfirm }) {
  if (!item) return null;
  return (
    <Backdrop
      open
      onClick={onClose}
      sx={{ zIndex: (theme) => theme.zIndex.drawer + 2, alignItems: "flex-start", pt: { xs: 4, md: 8 } }}
    >
      <Paper
        onClick={(e) => e.stopPropagation()}
        elevation={4}
        sx={{ width: { xs: "92vw", sm: 420 }, borderRadius: "16px", p: 0, outline: "none" }}
      >
        {/* Header */}
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            px: 3,
            py: 2,
            borderBottom: "1px solid #e5e7eb",
            borderRadius: "16px 16px 0 0",
          }}
        >
          <Typography sx={{ fontSize: 15, fontWeight: 700, color: "#111827" }}>
            Delete &ldquo;{item.name}&rdquo;?
          </Typography>
          <IconButton size="small" onClick={onClose} sx={{ color: "#6b7280" }}>
            <CloseIcon fontSize="small" />
          </IconButton>
        </Box>

        {/* Body */}
        <Box sx={{ p: 3 }}>
          <Box
            sx={{
              bgcolor: "#fff7ed",
              border: "1px solid #fed7aa",
              borderRadius: "8px",
              px: 2,
              py: 1.5,
              mb: 3,
            }}
          >
            <Typography sx={{ fontSize: 13, color: "#92400e" }}>
              This action cannot be undone. The record will be permanently removed from the database.
            </Typography>
          </Box>

          <Box sx={{ display: "flex", gap: 1.5, justifyContent: "flex-end" }}>
            <Box
              onClick={onClose}
              sx={{
                px: 3, py: 1, fontSize: 13, fontWeight: 600, borderRadius: "8px",
                border: "1px solid #e5e7eb", cursor: "pointer", color: "#374151",
                bgcolor: "#fff", "&:hover": { bgcolor: "#f9fafb" },
              }}
            >
              Cancel
            </Box>
            <Box
              onClick={onConfirm}
              sx={{
                px: 3, py: 1, fontSize: 13, fontWeight: 600, borderRadius: "8px",
                cursor: "pointer", color: "#fff", bgcolor: "#ef4444",
                "&:hover": { bgcolor: "#dc2626" },
              }}
            >
              Delete
            </Box>
          </Box>
        </Box>
      </Paper>
    </Backdrop>
  );
}
